import { Grid } from '@mui/material';
import { motion } from 'framer-motion';

import Card from '../../components/Card/Card';
import { projects } from '../../utils/projects';
import { workAnimation, workTransition } from '../../animations/work';
import './Work.css';

const Work = () => {
  return (
    <div className="work">
      <motion.div
        className="work__wrapper"
        initial="out"
        animate="in"
        variants={workAnimation}
        transition={workTransition}
      >
        <h2 className="work__title">My Work</h2>
        <Grid container justify="center" spacing={2}>
          {projects.map((project) => {
            const { id } = project;
            return (
              <Grid key={id} item xs={12} sm={6} md={4} lg={4} xl={3}>
                <Card project={project} />
              </Grid>
            );
          })}
        </Grid>
      </motion.div>
    </div>
  );
};

export default Work;
